export default {
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'modified',
      orderAsc: 0,

      type: 'all',
      isLoading: false,
      status: 'activated',
      serviceFilter: '',
      search: '',
      selectedUser: [],
      serviceType: '',

      tnc: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 20,
        order: 'created',
        orderAsc: 0,
        loading: false,
        selectedUser: []
      },
      tcp: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 20,
        order: 'created',
        orderAsc: 0,
        loading: false,
        selectedUser: []
      },
      psc: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 20,
        order: 'created',
        orderAsc: 0,
        loading: false,
        selectedUser: []
      }
    }
  },
  mutations: {
    resetUsers (state, value)  { state.users[value].list = [] },
    addUser (state, value) { state.users[value.target].list.push(value) },
    setUserMaxList (state, data) { state.users[data.target].maxList = data.value },
    setUserCurrentPage (state, data) { state.users[data.target].currentPage = data.value },
    setUserPerPage (state, data) { state.users[data.target].perPage = data.value },
    setUserOrder (state, data) { state.users[data.target].order = data.value },
    setUserOrderAsc (state, data) { state.users[data.target].orderAsc = data.value },
    setUserType (state, value) { state.users.type = value },
    setUserIsLoading (state, data) { state.users[data.target].loading = data.value },
    setUserStatus (state, value) { state.users.status = value },
    setUserServiceFilter (state, value) { state.users.serviceFilter = value },
    setUserSearch (state, value) { state.users.search = value },
    setUserSelected (state, data) { state.users[data.target].selectedUser = data.value },
    setUserServiceType (state, value) { state.users.serviceType = value },
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/provider/list.js